/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx'

const BgBlurModal = ({ children, setBgBlurModal }) => {
    const [showModal, setShowModal] = useState(false);
    useEffect(() => {
        setShowModal(true);
    }, [])
    return (
        <div className={`text-white fixed inset-0 !top-0 z-[1000] flex overflow-auto items-center justify-center bg-white bg-opacity-10 backdrop-blur-sm`}>
            <div className={`${showModal ? 'scale-100' : 'scale-0'} md:w-fit w-full sm:mx-10 mx-2 h-fit rounded-lg bg-richblack-700 p-4 relative transition-transform duration-300 origin-center`}>

                {children}

                <button
                    className='text-2xl text-richblack-5 absolute top-2 right-2'
                    onClick={() => setBgBlurModal(null)}
                >
                    <RxCross2 />
                </button>
            </div>
        </div>
    );
};

export default BgBlurModal;
